import { render, staticRenderFns } from "./PurchaseDuoItems.vue?vue&type=template&id=4637b614&"
import script from "./PurchaseDuoItems.vue?vue&type=script&lang=js&"
export * from "./PurchaseDuoItems.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports